module.exports = __webpack_public_path__ + "static/logo-35778ca35f35b4d233e17e0bfdaaeec8.svg";